<template>
  <b-modal
    id="keyword-chart-modal"
    ref="keywordChartModal"
    :title="modalTitle"
    modal-class="keyword-chart--modal"
    hide-footer
    size="lg">
    <BarChart
      :styles="{'height' : '300px'}"
      :options="chartOptions"
      :chart-data="keywordChartData"
      chart-id="keyword-chart"
      class="mb-4"/>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BarChart from '../../../common/charts/Bar';

export default {
  name: 'KeywordChartModal',
  components: {
    BarChart,
  },
  props: {
    chartLabels: {
      type: Array,
      default: () => [],
    },
    dates: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      keyword: '',
      keywordChartData: {},
      chartOptions: {
        maintainAspectRatio: false,
        legend: {
          labels: {
            usePointStyle: true,
            fontColor: '#253756',
          },
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        scales: {
          // xAxes: [{
          // }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              precision: 0,
            },
          }],
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      analytics: 'automation/keywordAnalytics',
    }),
    modalTitle() {
      switch (this.keyword) {
        case 'default':
          return 'Default Reply Analytics';
        case 'away':
          return 'Away Reply Analytics';
        default:
          return `${this.keyword} Keyword Analytics`;
      }
    },
  },
  watch: {
    analytics(analytics) {
      this.fillChartData(analytics);
    },
  },
  methods: {
    ...mapActions({
      fetchKeywordAnalytics: 'automation/fetchKeywordAnalytics',
    }),
    loadAnalytics(reply) {
      this.keyword = reply.keyword;
      this.fetchKeywordAnalytics({
        merchant_id: this.$route.params.merchant_id,
        reply_id: reply.id,
        data: this.dates,
      });
    },
    fillChartData(analytics) {
      this.keywordChartData = {
        labels: this.chartLabels,
        datasets: [
          {
            label: 'All Interactions',
            backgroundColor: 'rgba(61, 139, 252, 0.45)',
            borderColor: 'rgb(61, 139, 252)',
            data: Object.values(analytics.all_interactions),
          },
          {
            label: 'Unique Interactions',
            backgroundColor: 'rgba(121, 113, 234, 0.45)',
            borderColor: 'rgb(121, 113, 234)',
            data: Object.values(analytics.unique_interactions),
          },
        ],
      };
    },
    show() {
      this.$refs.keywordChartModal.show();
    },
    hide() {
      this.$refs.keywordChartModal.hide();
    },
  },
};
</script>
